export default __webpack_public_path__ + "static/livingetc-cityetc-october-2018-551cfebcd191a50d2ea9a90fa4445b6b.pdf";